import { useSelector } from "react-redux";
import ComboBox from "../../Control/ComboBox/ComboBox";
import { ColumnLabel } from "../../Layout/ColumnLabel";
import { AppState } from "../../../appSlice";
import { RootState } from "../../../store";
import { useEffect, useState } from "react";
import { ComboBoxOption } from "../../../models/Input";
import { MATH_OPERATOR_OPTIONS, MathOperator } from "../../../models/Math";
import { ToggleButton } from "../../Control/ToggleButton";

export type CategorySelectorProps = {
    values: ComboBoxOption<string>[] | null,
    update: (values: ComboBoxOption<string>[] | null) => void,
    isAnd: boolean,
    updateIsAnd: (value: boolean) => void
}

export function CategorySelector(props: CategorySelectorProps) {
    const { categories } = useSelector<RootState, AppState>(x => x.app);
    const [categoryOptions, setCategoryOptions] = useState<ComboBoxOption<string>[]>([]);

    useEffect(() => {
        setCategoryOptions(categories.map(x => ({ label: x, value: x })));
    }, [categories]);

    return (
        <ColumnLabel label="Category" classNames={{ column2: "flex gap-2 flex-row" }}>
            <ToggleButton value={props.isAnd} update={(value) => props.updateIsAnd(value)} text={{ on: "AND", off: "OR" }} classNames={{ button: "w-[50px]" }} />

            <div className="flex-1">
                <ComboBox
                    selections={props.values}
                    isMulti={true}
                    isClearable={true}
                    options={categoryOptions}
                    onChange={(newSelections) => props.update(newSelections ? JSON.parse(JSON.stringify(newSelections)) : null)} />
            </div>
        </ColumnLabel>
    )
}